var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolagem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "73e083120c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 96 213 L 105 213 L 105 228.683594 L 96 228.683594 Z M 96 213 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53e16d8bd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 154 213 L 163 213 L 163 228.683594 L 154 228.683594 Z M 154 213 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68252c08b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 213.332031 L 47.585938 213.332031 L 47.585938 228.601562 L 37.5 228.601562 Z M 37.5 213.332031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce88195b8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 269 213 L 280 213 L 280 228.683594 L 269 228.683594 Z M 269 213 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ed345743c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 328.488281 213.589844 L 337.5 213.589844 L 337.5 228.601562 L 328.488281 228.601562 Z M 328.488281 213.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2395ed4a8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.804688 213.332031 L 220.949219 213.332031 L 220.949219 228.601562 L 211.804688 228.601562 Z M 211.804688 213.332031 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 43.101562 202.785156 L 41.9375 202.785156 L 41.9375 159.011719 L 43.101562 159.011719 L 43.101562 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 48.910156 186.984375 L 47.75 186.984375 L 47.75 159.011719 L 48.910156 159.011719 L 48.910156 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 54.71875 186.984375 L 53.558594 186.984375 L 53.558594 159.011719 L 54.71875 159.011719 L 54.71875 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 60.53125 186.984375 L 59.367188 186.984375 L 59.367188 159.011719 L 60.53125 159.011719 L 60.53125 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 66.339844 186.984375 L 65.175781 186.984375 L 65.175781 159.011719 L 66.339844 159.011719 L 66.339844 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 72.148438 202.785156 L 70.988281 202.785156 L 70.988281 159.011719 L 72.148438 159.011719 L 72.148438 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 77.957031 186.984375 L 76.796875 186.984375 L 76.796875 159.011719 L 77.957031 159.011719 L 77.957031 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 83.769531 186.984375 L 82.605469 186.984375 L 82.605469 159.011719 L 83.769531 159.011719 L 83.769531 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 89.578125 186.984375 L 88.417969 186.984375 L 88.417969 159.011719 L 89.578125 159.011719 L 89.578125 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 95.386719 186.984375 L 94.226562 186.984375 L 94.226562 159.011719 L 95.386719 159.011719 L 95.386719 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 101.199219 202.785156 L 100.035156 202.785156 L 100.035156 159.011719 L 101.199219 159.011719 L 101.199219 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 107.007812 186.984375 L 105.84375 186.984375 L 105.84375 159.011719 L 107.007812 159.011719 L 107.007812 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 112.816406 186.984375 L 111.65625 186.984375 L 111.65625 159.011719 L 112.816406 159.011719 L 112.816406 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 118.625 186.984375 L 117.464844 186.984375 L 117.464844 159.011719 L 118.625 159.011719 L 118.625 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 124.4375 186.984375 L 123.273438 186.984375 L 123.273438 159.011719 L 124.4375 159.011719 L 124.4375 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 130.246094 202.785156 L 129.085938 202.785156 L 129.085938 159.011719 L 130.246094 159.011719 L 130.246094 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 136.054688 186.984375 L 134.894531 186.984375 L 134.894531 159.011719 L 136.054688 159.011719 L 136.054688 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 141.867188 186.984375 L 140.703125 186.984375 L 140.703125 159.011719 L 141.867188 159.011719 L 141.867188 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 147.675781 186.984375 L 146.511719 186.984375 L 146.511719 159.011719 L 147.675781 159.011719 L 147.675781 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 153.484375 186.984375 L 152.324219 186.984375 L 152.324219 159.011719 L 153.484375 159.011719 L 153.484375 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 159.292969 202.785156 L 158.132812 202.785156 L 158.132812 159.011719 L 159.292969 159.011719 L 159.292969 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 165.105469 186.984375 L 163.941406 186.984375 L 163.941406 159.011719 L 165.105469 159.011719 L 165.105469 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 170.914062 186.984375 L 169.75 186.984375 L 169.75 159.011719 L 170.914062 159.011719 L 170.914062 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 176.722656 186.984375 L 175.5625 186.984375 L 175.5625 159.011719 L 176.722656 159.011719 L 176.722656 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 182.535156 186.984375 L 181.371094 186.984375 L 181.371094 159.011719 L 182.535156 159.011719 L 182.535156 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 188.34375 202.789062 L 187.179688 202.789062 L 187.179688 159.011719 L 188.34375 159.011719 L 188.34375 202.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 194.152344 186.984375 L 192.992188 186.984375 L 192.992188 159.011719 L 194.152344 159.011719 L 194.152344 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 199.960938 186.984375 L 198.800781 186.984375 L 198.800781 159.011719 L 199.960938 159.011719 L 199.960938 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 205.773438 186.984375 L 204.609375 186.984375 L 204.609375 159.011719 L 205.773438 159.011719 L 205.773438 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 211.582031 186.984375 L 210.417969 186.984375 L 210.417969 159.011719 L 211.582031 159.011719 L 211.582031 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 217.390625 202.789062 L 216.230469 202.789062 L 216.230469 159.011719 L 217.390625 159.011719 L 217.390625 202.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 223.199219 186.984375 L 222.039062 186.984375 L 222.039062 159.011719 L 223.199219 159.011719 L 223.199219 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 229.011719 186.984375 L 227.847656 186.984375 L 227.847656 159.011719 L 229.011719 159.011719 L 229.011719 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 234.820312 186.984375 L 233.660156 186.984375 L 233.660156 159.011719 L 234.820312 159.011719 L 234.820312 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 240.628906 186.984375 L 239.46875 186.984375 L 239.46875 159.011719 L 240.628906 159.011719 L 240.628906 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 246.441406 202.785156 L 245.277344 202.785156 L 245.277344 159.011719 L 246.441406 159.011719 L 246.441406 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 252.25 186.984375 L 251.085938 186.984375 L 251.085938 159.011719 L 252.25 159.011719 L 252.25 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 258.058594 186.984375 L 256.898438 186.984375 L 256.898438 159.011719 L 258.058594 159.011719 L 258.058594 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 263.871094 186.984375 L 262.707031 186.984375 L 262.707031 159.011719 L 263.871094 159.011719 L 263.871094 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 269.679688 186.984375 L 268.515625 186.984375 L 268.515625 159.011719 L 269.679688 159.011719 L 269.679688 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 275.488281 202.789062 L 274.328125 202.789062 L 274.328125 159.011719 L 275.488281 159.011719 L 275.488281 202.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 281.296875 186.984375 L 280.136719 186.984375 L 280.136719 159.011719 L 281.296875 159.011719 L 281.296875 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 287.109375 186.984375 L 285.945312 186.984375 L 285.945312 159.011719 L 287.109375 159.011719 L 287.109375 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 292.917969 186.984375 L 291.757812 186.984375 L 291.757812 159.011719 L 292.917969 159.011719 L 292.917969 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 298.726562 186.984375 L 297.566406 186.984375 L 297.566406 159.011719 L 298.726562 159.011719 L 298.726562 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 304.535156 202.789062 L 303.375 202.789062 L 303.375 159.011719 L 304.535156 159.011719 L 304.535156 202.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 310.347656 186.984375 L 309.1875 186.984375 L 309.1875 159.011719 L 310.347656 159.011719 L 310.347656 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 316.15625 186.984375 L 314.992188 186.984375 L 314.992188 159.011719 L 316.15625 159.011719 L 316.15625 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 321.96875 186.984375 L 320.804688 186.984375 L 320.804688 159.011719 L 321.96875 159.011719 L 321.96875 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 327.777344 186.984375 L 326.613281 186.984375 L 326.613281 159.011719 L 327.777344 159.011719 L 327.777344 186.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d4f8e",
    d: "M 333.585938 202.785156 L 332.421875 202.785156 L 332.421875 159.011719 L 333.585938 159.011719 L 333.585938 202.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#73e083120c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d4e8d",
    d: "M 102.226562 213.628906 L 102.226562 226.667969 L 104.714844 226.667969 L 104.714844 228.351562 L 97.355469 228.351562 L 97.355469 226.667969 L 100.34375 226.667969 L 100.34375 216.046875 L 97.542969 218.171875 L 96.515625 216.761719 L 100.847656 213.628906 L 102.226562 213.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53e16d8bd6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d4e8d",
    d: "M 154.28125 228.351562 C 154.238281 228.097656 154.21875 227.84375 154.21875 227.570312 C 154.21875 222.144531 160.804688 220.253906 160.804688 217.097656 C 160.804688 215.921875 159.84375 215.058594 158.484375 215.058594 C 157.3125 215.058594 156.371094 215.5625 155.535156 216.34375 L 154.488281 215.058594 C 155.597656 214.050781 156.914062 213.375 158.691406 213.375 C 161.160156 213.375 162.792969 214.953125 162.792969 216.972656 C 162.792969 221.03125 156.789062 222.902344 156.328125 226.625 L 162.773438 226.625 L 162.773438 228.351562 L 154.28125 228.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68252c08b0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d4e8d",
    d: "M 39.488281 220.949219 C 39.488281 224.816406 40.617188 226.878906 42.519531 226.878906 C 44.382812 226.878906 45.554688 225.382812 45.554688 221.03125 C 45.554688 217.160156 44.421875 215.101562 42.519531 215.101562 C 40.660156 215.101562 39.488281 216.59375 39.488281 220.949219 Z M 47.539062 221.011719 C 47.539062 225.867188 45.742188 228.601562 42.5 228.601562 C 39.234375 228.601562 37.5 225.804688 37.5 220.96875 C 37.5 216.109375 39.300781 213.375 42.539062 213.375 C 45.804688 213.375 47.539062 216.171875 47.539062 221.011719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce88195b8f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d4e8d",
    d: "M 278.109375 225.214844 L 278.109375 228.351562 L 276.226562 228.351562 L 276.226562 225.214844 L 269.972656 225.214844 L 269.972656 223.703125 L 274.34375 213.480469 L 275.972656 214.175781 L 272.019531 223.492188 L 276.226562 223.492188 L 276.226562 219.308594 L 278.109375 219.308594 L 278.109375 223.492188 L 279.84375 223.492188 L 279.84375 225.214844 L 278.109375 225.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ed345743c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d4e8d",
    d: "M 332.378906 228.601562 C 330.664062 228.601562 329.511719 228.203125 328.507812 227.507812 L 329.492188 225.890625 C 330.265625 226.457031 331.207031 226.878906 332.402344 226.878906 C 334.261719 226.878906 335.515625 225.679688 335.515625 223.996094 C 335.515625 222.25 334.28125 221.03125 332.085938 221.03125 L 329.492188 221.03125 L 329.492188 213.628906 L 336.730469 213.628906 L 336.730469 215.332031 L 331.269531 215.332031 L 331.269531 219.328125 L 332.316406 219.328125 C 335.558594 219.328125 337.503906 221.179688 337.503906 223.785156 C 337.503906 226.605469 335.453125 228.601562 332.378906 228.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2395ed4a8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d4e8d",
    d: "M 211.875 227.339844 L 212.734375 225.761719 C 213.507812 226.351562 214.488281 226.878906 215.972656 226.878906 C 217.816406 226.878906 218.964844 225.785156 218.964844 224.3125 C 218.964844 222.777344 217.753906 221.453125 215.011719 221.453125 L 213.839844 221.453125 L 213.839844 219.917969 L 214.929688 219.917969 C 217.398438 219.917969 218.566406 218.613281 218.566406 217.265625 C 218.566406 215.964844 217.4375 215.058594 215.996094 215.058594 C 214.679688 215.058594 213.652344 215.585938 213.003906 216.109375 L 212.230469 214.617188 C 213.066406 214.050781 214.382812 213.375 216.140625 213.375 C 218.882812 213.375 220.46875 215.082031 220.46875 217.015625 C 220.46875 218.675781 219.613281 219.75 218.109375 220.484375 C 219.863281 221.15625 220.910156 222.503906 220.910156 224.25 C 220.910156 226.457031 219.320312 228.601562 215.953125 228.601562 C 214.132812 228.601562 212.816406 228.035156 211.875 227.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolagem);
export default __webpack_public_path__ + "static/media/rolagem.f7328811680944ce116ee1f74529b61d.svg";
export { ForwardRef as ReactComponent };